exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fade-transition[data-v-d7371f94]{-webkit-transition:opacity .2s ease;transition:opacity .2s ease}.fade-enter[data-v-d7371f94],.fade-leave[data-v-d7371f94]{opacity:0}.tabs .tab[data-v-d7371f94]{background-color:transparent!important;-webkit-transition:.5s!important;transition:.5s!important}.tabs .tab[data-v-d7371f94]:active,.tabs .tab[data-v-d7371f94]:hover{background-color:rgba(158,202,254,.35)!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d7371f94","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/stages/Widgets/Settings.vue
// module id = 9re3
// module chunks = 1 2